<template lang="pug">
footer.footer(:class="{'footer-no-mt': isInscription}")
    .container
        .row
            .col-12.col-sm-12.col-md-6.col-lg-2.d-flex.align-items-center
                img.img-fluid.mb-3(:src="logo")
            .col-md-6.col-lg-3.col-sm-12.col-12
                p.tf_prez Tendfox est un outil qui permet d’avoir une vue globale sur l’économie d’un pays, son actualité, l’ensemble de ses données financières, accès au profiles du tissus économique et fournir un outil puissant d’achat et de mises en relation
            .col-md-6.col-lg-4.col-sm-12.d-flex.justify-content-center.align-items-center.tf_links
                ul.contact.list-inline
                    li.list-inline-item
                        router-link(to='/faq', tag='a',exact) Aide
                    li.list-inline-item |
                    li.list-inline-item
                        router-link(to='/document', tag='a',exact) Documents utiles
                    li.list-inline-item |
                    li.list-inline-item
                        router-link(to='/tos', tag='a',exact) CGU
                    //li.list-inline-item
                        a(href='https://www.facebook.com/Tendfox', target='_blank')
                            img.mr-2(:src="facebook" width='30')
            .col-lg-3.col-md-6.col-sm-12.col-xs-12
                ul.list-unstyled.tf_footer_contact
                  li
                    span.icon
                      svg(xmlns='http://www.w3.org/2000/svg', width='18', height='18', viewBox='0 0 24 24')
                        path(d='M0 0h24v24H0z', fill='none')
                        path(d='M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z')
                    span +213 (0) 560 545 282
                  li
                    span.icon
                      i.fa.fa-phone
                    span +213 (0) 21 28 76 46
                  li
                    span.icon
                      i.fa.fa-facebook
                    a(href='https://www.facebook.com/Tendfox', target='_blank') Suivez nous
                  li
                    span.icon
                      i.fa.fa-envelope
                    span contact@tendfox.com
    .bottom-bar
        .container
            p.text-center © {{ year }} www.tendfox.com - All rights reserved.

</template>
<script>
import service from '@/assets/images/service_comercial.png'
import facebook from '@/assets/images/Facebook-icon-.png'
import logo from '@/assets/images/logo.png'
import logo2 from '@/assets/images/logo2.png'
import store from './store/DataStore'
import Vuex from 'vuex'
global.v = Vuex
export default {
  store: store,
  data () {
    return {
      service: service,
      logo: logo,
      logo2: logo2,
      facebook: facebook,
      year: new Date().getFullYear()
    }
  },
  computed: {
    ...Vuex.mapGetters(['homeMenu']),
    isInscription () {
      return this.$route.name === 'Inscription'
    }
  }
}
</script>

<style lang="css">
  .footer-no-mt {
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue